module.exports = __webpack_public_path__ + "assets/img/陈姣-code.ecf81e6f.jpg";